<template>
  <div style="margin: 0 16px 24px;">
    <div class="stock-info">
        <div class="stock-info-text">
          <div class="info-item"><p class="info-title">所属门店：</p><span>{{stockForm.shopName}}</span></div>
          <div class="info-item"><p class="info-title">关联批次号：</p><span>{{stockForm.numberNo}}</span></div>
          <div class="info-item"><p class="info-title">添加人：</p><span>{{stockForm.adminName}}</span></div>

        </div>
        <div class="stock-info-text" v-if="stockForm.state != 5">
          <div class="info-item"><p class="info-title">入库类型：</p><span>{{stockForm.type == -5?'核销券码':stockForm.type == -4?'报损出库':stockForm.type == -3?'赠送出库':stockForm.type == -2?'售卖出库':stockForm.type == -1?'系统出库':stockForm.type == 1?'系统入库':stockForm.type == 2?'采购入库':'' }}</span></div>
          <div class="info-item"><p class="info-title">入库时间：</p><span>{{stockForm.updateTime}}</span></div>
          <div class="info-item"><p class="info-title">入库数量：</p><span>{{stockForm.stockStatNum.num}}</span></div>
        </div>
        <div class="stock-info-text" v-if="stockForm.state != 5">
          <div class="info-item"><p class="info-title">入库总计：</p><span>{{stockForm.stockStatNum.money}}</span></div>
          <div class="info-item"><p class="info-title" v-if="stockForm.type != 1">快递单号：</p><span>{{stockForm.trackingNumber}}</span></div>
          <div class="info-item"><p class="info-title" v-if="stockForm.type != 1">发货地址：</p><span>{{stockForm.shipAddress}}</span></div>
        </div>

        <div class="stock-info-text" v-if="stockForm.state == 5">
          <div class="info-item"><p class="info-title">出库类型：</p><span>{{stockForm.type == -5?'核销券码':stockForm.type == -4?'报损出库':stockForm.type == -3?'赠送出库':stockForm.type == -2?'售卖出库':stockForm.type == -1?'系统出库':stockForm.type == 1?'系统入库':stockForm.type == 2?'采购入库':'' }}</span></div>
          <div class="info-item"><p class="info-title">出库时间：</p><span>{{stockForm.updateTime}}</span></div>
          <div class="info-item"><p class="info-title">出库数量：</p><span>{{stockForm.stockStatNum.num}}</span></div>
        </div>
        <div class="stock-info-text" v-if="stockForm.state == 5">
          <div class="info-item" v-if="stockForm.type == -5 || stockForm.type == -3 || stockForm.type == -2"><p class="info-title">消费单号：</p><span>{{stockForm.consumeNumberNo}}</span></div>
          <div class="info-item"><p class="info-title">出库总计：</p><span>{{stockForm.stockStatNum.money}}</span></div>
          <div class="info-item" v-if="stockForm.type == -5 || stockForm.type == -3 || stockForm.type == -2"><p class="info-title">主人手机：</p><span>{{stockForm.consumeUserPhone}}</span></div>
        </div>

        <div class="stock-info-text" v-if="stockForm.state != 5 && stockForm.type !=1">
          <div class="info-item"><p class="info-title">快递运费：</p><span>{{stockForm.freight}}</span></div>
          <div class="info-item">
            <p class="info-title">入库货单：</p>
<!--            <el-image class="item-img cursor" fit="cover" style="width: 40px; height: 40px;" :src="stockForm.waybillSmallImg" @click="showImg(stockForm.waybillImg)">-->
<!--              <template #error>-->
<!--                <div class="el-img-error" style="font-size: 8px;">暂无图片</div>-->
<!--              </template>-->
<!--            </el-image>-->
            <div v-if="stockForm.stockImgList.length > 0" class="cursor" @click="userImgList(stockForm.stockImgList)">
              <el-image class="item-img" style="width: 40px; height: 40px;" fit="fill" :src="stockForm.stockImgList[0].img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" style="width: 40px; height: 40px;" fit="fill"><template #error><div class="el-img-error" style="font-size: 8px;">暂无图片</div></template></el-image>
            </div>
          </div>
        </div>
    </div>
    <div class="content-table" style="width: 100%; margin-top: 16px">
      <div style="margin-bottom: 16px;" v-if="stockForm.state != 4 && stockForm.state != 5">
        <el-button type="primary" v-loading="batchLoading" @click="batchUpdate(3)">批量入库</el-button>
        <el-button type="danger" v-loading="batchLoading" @click="batchUpdate(2)">批量驳回</el-button>
      </div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          v-loading="listLoading"
          @selection-change="selsChange"
          @header-click="selsAll"
          @cell-click="toggleSelection"
          size="default"
          style="width: 100%"
          height="480"
          border
      >
        <el-table-column type="selection" width="55" align="center" class-name="cursor" v-if="stockForm.state != 4 && stockForm.state != 5"/>
        <el-table-column property="supplierName" label="供应商" />
        <el-table-column property="brandName" label="品牌" />
        <el-table-column property="commodityName" label="商品名称" />
        <el-table-column property="" label="商品图片" >
          <template #default="scope">
            <div v-if="scope.row.commodityImgList.length > 0" class="cursor" @click="userImgList(scope.row.commodityImgList)">
              <el-image class="item-img" fit="cover" :src="scope.row.commodityImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
            <div v-else>
              <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="" label="商品分类">
          <template #default="scope">
<!--            {{scope.row.commodityTypePreName}}{{scope.row.commodityTypeName}}-->
            {{scope.row.commodityTypePreName?scope.row.commodityTypePreName + '/':''}}{{scope.row.commodityTypeName}}
          </template>
        </el-table-column>
        <el-table-column property="specification" label="商品规格" />
        <el-table-column property="measureUnitName" label="计量单位" />
        <el-table-column property="price" width="82" :label="stockForm.state == 5?'商品售价':'进货单价'" />
        <el-table-column property="retailPrice" label="建议零售价" width="100"/>
        <el-table-column property="num" label="采购数量"  v-if="stockForm.type == 2"/>
        <el-table-column property="giveNum" label="赠送数量"  v-if="stockForm.type == 2"/>
        <el-table-column property="num"  :label="stockForm.state == 5?'出库数量':'入库数量'">
          <template #default="scope">
            {{scope.row.num + scope.row.giveNum}}
          </template>
        </el-table-column>
        <el-table-column property="reduceMoney" label="优惠金额"  v-if="stockForm.type == 2"/>
        <el-table-column property="" width="82" :label="stockForm.state == 5?'出库总计':'入库总计'">
          <template #default="scope">
<!--            {{Number(scope.row.num)*Number(scope.row.price)}}-->
            {{scope.row.stockSum}}
          </template>
        </el-table-column>
        <el-table-column property="stockNum" label="入库后数量" width="100" v-if="stockForm.state == 4"/>
        <el-table-column property="stockNum" label="出库后数量" width="100" v-if="stockForm.state == 5"/>
        <el-table-column property="" label="状态" v-if="stockForm.state != 5" width="60">
          <template #default="scope">
            <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待提交':scope.row.state == 1?'待入库':scope.row.state == 2?'已驳回':scope.row.state == 3?'已入库':'' }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="stockForm.state != 4 && stockForm.state != 5">
          <template #default="scope">
            <el-space wrap>

              <el-button v-if="scope.row.state == 2 || scope.row.state == 1" v-loading="batchLoading" @click="singleUpdate(scope.$index,scope.row)" size="small" type="primary">入库</el-button>
              <el-button v-if="scope.row.state == 1" @click="reject(scope.$index,scope.row)" size="small" type="danger">驳回</el-button>
            </el-space>
          </template>
        </el-table-column>
      </el-table>
<!--      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--      </el-pagination>-->
    </div>
  </div>
</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";
import {getFormData, postFormData} from "@/api/api";
import {listStockCommodity, updatePurchaseState} from "@/api/url";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import Dialog from "@/assets/js/dialog";
import RefusalReasonDialog from "@/views/stock/components/RefusalReasonDialog";
import {mul, Number_SubAll} from "@/assets/shared/util";

export default {
  name: "StockListDialog",
  props: {
    value: Object
  },
  data() {
    return {
      stockForm: this.value.stockForm,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      idArray: [],

      batchLoading: false,

    }
  },
  methods: {
    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    userImgList(imgList) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: imgList,
          // id: row.commodityId,
          width: 908,
          from: 2,
          hideBtn: true
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    },

    // //分页
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   this.getPage();
    // },

    getPage() {
      this.searchLoading = true;
      this.listLoading = true;
      getFormData(listStockCommodity, {id: this.stockForm.id}).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.pageDataList = data['data'];
          this.pageDataList.map(item => {
            // item.stockSum = mul(Number(item.num), Number(item.price))
            item.stockSum = Number_SubAll(mul(Number(item.num), Number(item.price)), item.reduceMoney)
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      }).catch((response) => {
        this.searchLoading = false;
        this.listLoading = false;
      })
    },

    batchUpdate(state) {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择需要提交入库的商品',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确定批量' + (state == 2?'驳回':'入库') + '吗？').then(() => {
        this.batchLoading = true
        let param = {}
        param['idArr'] = this.idArray
        param['state'] = state
        param['stockId'] = this.stockForm.id
        postFormData(updatePurchaseState, param).then(data => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
            this.getPage()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        })
      })
    },

    singleUpdate(idx, row) {
      this.$confirm('确认入库商品【' + row.commodityName + '】的采购记录吗？').then(() => {
        this.batchLoading = true
        let arr = []
        arr.push(row.id)
        let param = {}
        param['idArr'] = arr
        param['state'] = 3
        param['stockId'] = this.stockForm.id
        postFormData(updatePurchaseState, param).then(data => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
            this.getPage()
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        })
      })
    },

    reject(idx, row) {
      let _title = '确认驳回商品【' + row.commodityName + '】的采购记录吗？';
      let arr = []
      arr.push(row.id)
      Dialog.open({
        title: _title,
        component: RefusalReasonDialog,
        data: {
          idArr: arr,
          stockId: this.stockForm.id,
          width: '500px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

  },

  mounted() {
    this.getPage()
  }


}
</script>

<style scoped>
.stock-info{
  display: flex;
  align-items: center;
  justify-content: space-around;
  /*background-color: #f5f7fa;*/
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 24px;
}
.item-img {
  width: 56px;
  height: 56px;
}
.stock-info-img {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.stock-info-text {
  width: 25%;
}

.info-title{
  /*width: 70px;*/
  /*text-align: right;*/
  font-weight: bold;
}

.info-item {
  display: flex;
  align-items: center;
  margin: 3px 0;
}
</style>
